import HomepageHero from '@/components/HomepageHero';
import AboutSection from '@/components/AboutSection';
import CourseOverview from '@/components/CourseOverview';
import TestimonialCarousel from '@/components/TestimonialCarousel';
import FAQSection from '@/components/FAQSection';

const Index = () => {
  return (
    <main>
      <HomepageHero />
      <AboutSection />
      <CourseOverview />
      <TestimonialCarousel />
      <FAQSection />
    </main>
  );
};

export default Index;